import React from 'react';
import clsx from 'clsx';
import styles from '../FundingHistory.module.scss';
import FundingTableRow from './FundingTableRow';
import { FUNDING_AMOUNT_HEADER_ID } from '../constants';
import SummaryRow from './SummaryRow';
import EmptyDataRow from './EmptyDataRow';

interface FundingTableProps {
    headers: Array<{ id: string; label: string }>;
    fundingData: any[];
    debentureData: any[];
    totalFundingAmount: number;
    totalDebentureAmount: number;
    isPDFReport: boolean;
    showFundingData: boolean;
    showDebentureData: boolean;
    taskTrackerStatus: string;
    emptyMessage: string;
    fundingTotalTitle?: string;
}

function FundingTable({
    headers,
    fundingData,
    debentureData,
    totalFundingAmount,
    totalDebentureAmount,
    isPDFReport,
    showFundingData,
    showDebentureData,
    taskTrackerStatus,
    emptyMessage,
    fundingTotalTitle = 'Total Funding Raised',
}: FundingTableProps) {
    return (
        <div className={clsx(styles.table, { [styles.tableDashboard]: !isPDFReport })}>
            <div className={styles.tableHeader}>
                {headers.map((header) => (
                    <div
                        className={clsx(styles.headerItem, {
                            [styles.alignRight]: isPDFReport && header.id === FUNDING_AMOUNT_HEADER_ID,
                        })}
                        key={header.id}
                        title={!isPDFReport && header.label ? header.label : undefined}
                    >
                        {header.label}
                    </div>
                ))}
            </div>
            <div className={styles.tableBody}>
                {/* No Data Message - only show if taskTrackerStatus is not FAILED */}
                {!showFundingData && !showDebentureData && taskTrackerStatus !== 'FAILED' && <EmptyDataRow message={emptyMessage} />}

                {/* Funding History Data */}
                {showFundingData &&
                    fundingData?.map((item, rowIndex) => (
                        <FundingTableRow key={`funding-${rowIndex}`} data={item} headers={headers} isPDFReport={isPDFReport} />
                    ))}

                {/* Total Funding Raised Summary Row */}
                {showFundingData && <SummaryRow title={fundingTotalTitle} amount={totalFundingAmount} headers={headers} />}

                {/* Debenture History Data */}
                {showDebentureData &&
                    debentureData?.map((item, rowIndex) => (
                        <FundingTableRow key={`debenture-${rowIndex}`} data={item} headers={headers} isPDFReport={isPDFReport} />
                    ))}

                {/* Total Debentures Issued Summary Row */}
                {showDebentureData && <SummaryRow title="Total Debentures Issued" amount={totalDebentureAmount} headers={headers} />}
            </div>
        </div>
    );
}

export default FundingTable;
